import { render, staticRenderFns } from "./footer-one.vue?vue&type=template&id=77acbd46&scoped=true"
import script from "./footer-one.vue?vue&type=script&lang=js"
export * from "./footer-one.vue?vue&type=script&lang=js"
import style0 from "./footer-one.vue?vue&type=style&index=0&id=77acbd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77acbd46",
  null
  
)

export default component.exports